import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import Header from 'src/Layout/Header/view';
import Sidebar from 'src/Layout/Sidebar/view';
import { Container, Body, Main } from './styles';
import { MobileWrapper } from 'src/Layout/MobileWrapper/MobileWrapper';
import FeatureErrorBoundary from 'src/components/FeatureErrorBoundary';

function MainWrapper({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <MobileWrapper>
      <Container>
        {!isMobile && <Sidebar />}
        <Body $isMobile={isMobile} style={{ width: isMobile ? '100%' : 'calc(100% - 230px)' }}>
          {!isMobile && <Header />}
          <Main
            style={{
              marginTop: isMobile ? 0 : '80px',
              marginBottom: isMobile ? '20px' : 0,
              paddingBottom: isMobile ? '20px' : 0,
              paddingTop: isMobile ? 0 : '20px',
            }}
          >
            <FeatureErrorBoundary>{children}</FeatureErrorBoundary>
          </Main>
        </Body>
      </Container>
    </MobileWrapper>
  );
}

export default MainWrapper;
